export default {
  'ALTERAR_USUARIO' (state, payload) {
    state.usuario = payload;
  }
};
